import React from 'react'
import { observer } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../input/date'
import Filters from '../global_filters'
import ListView from 'bstrap-react-mobx-admin/view/list'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import { ButtonGroup, Button } from 'react-bootstrap'

const YTAssetsListView = ({ store }) => {
  //
  if (!store.hasRight(linkConst.LINK_YOUTUBE_ASSETS)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const fields = [
    (attr, row) => {
      const DetailLink = ({ text }) => (
        <div className='nowrap'>
          <a href='javascript:void(0)' onClick={() => store.detailClicked(row)}>{text}</a>
          <a href={`/entity/${store.router.params.entityname}/${row.id}`}
            target="_blank" rel="noreferrer"
            title={store.__('Open link in new tab')} className="text-muted link-icon">
            <i className="glyphicon glyphicon-new-window" />
          </a>
        </div>
      )
      return <TextField attr={attr} val={row[attr]} Component={DetailLink} />
    },
    (attr, row) => {
      const DetailLink = ({ text }) => (
        <div className='nowrap'>
          {text}&nbsp;<a href={`https://studio.youtube.com/asset/${text}/metadata/overview?o=V6sUCxWfKb0HkJZl-8SRxw`}
            target="_blank" rel="noreferrer"
            title={store.__('Open link in new tab')} className="text-muted link-icon">
            <i className="glyphicon glyphicon-new-window" />
          </a>
        </div>
      )
      return <TextField attr={attr} val={row[attr]} Component={DetailLink} />
    },
    (attr, row) => {
      const DetailLink = ({ text }) => (
        <div className='nowrap' style={{ maxWidth: '250px', textOverflow: 'ellipsis', overflow: 'hidden' }}>
          <a href='javascript:void(0)'
            title={text} onClick={() => {
              store.assetTabEvent('basic', 2)
              store.assetTabEvent('flyprivate', 1)
              store.goTo('entity_detail', { entityname: 'films', id: row.video_id })
            }}><i className='glyphicon glyphicon-share-alt' /> {text}</a>
        </div>
      )
      return row.video_id ? <TextField attr={attr} val={row[attr]} Component={DetailLink} /> : ''
    },
    (attr, row) => (<TextField attr={attr} val={row[attr]} Component={({ text }) => <span>{text}</span>} />),
    (attr, row) => (<DateField attr={attr} val={row[attr]} />),
    (attr, row) => (
      <OptionsField attr={attr} val={row[attr]}
        options={store.options.get('UploadTypes')}
        labelattr='text'
        valueattr='value' />
    ),
    (attr, row) => (<TextField attr={attr} val={row[attr]} Component={({ text }) => <span>{text}</span>} />),
    (attr, row) => {
      const attrName = 'id'
      const thisVideoID = (row && row.video_id) || ''
      const DetailLink = ({ text }) => (
        <ButtonGroup style={{ width: '13em' }}>
          {thisVideoID > 0 &&
            <Button bsStyle='info' bsSize='sm' onClick={() => store.solvedAsset(text, null, row.video_id)}>
              <i className='glyphicon glyphicon-ok' />&nbsp; {store.__(defaultConst.TITLE_SOLVED)}
            </Button>}
          <Button bsStyle='danger' bsSize='sm' onClick={() => {
            if (confirm('Are you sure you want to remove item #' + text + '?')) { store.removedAsset(text) }
          }}>
            <i className='glyphicon glyphicon-remove' />&nbsp; {store.__(defaultConst.TITLE_REMOVE)}
          </Button>
        </ButtonGroup>
      )
      return <TextField attr={attrName} val={row[attrName]} Component={DetailLink} />
    }
  ]

  const batchActions = () => {
    return (
      <button className={defaultConst.ACTION_BUTTON_CLASS2} type='button' onClick={store.batchDelete.bind(store)}>
        <span className='glyphicon glyphicon-remove' />&nbsp;{store.__('Delete')}</button>
    )
  }
  const filters = {
    id_like: {
      title: 'ID',
      component: (props) => (<TextInput {...props} />)
    },
    title_like: {
      title: 'title',
      component: (props) => (<TextInput {...props} />)
    },
    video_id_like: {
      title: 'video_id',
      component: (props) => (<TextInput {...props} />)
    },
    asset_id_like: {
      title: 'asset_id',
      component: (props) => (<TextInput {...props} />)
    },
    asset_name_like: {
      title: 'asset_name',
      component: (props) => (<TextInput {...props} />)
    },
    asset_created_dt: {
      title: 'asset_created_dt',
      component: (props) => (<DateInput hideControlLabel {...props} />)
    },
    asset_type: {
      title: 'asset_type',
      component: (props) => (<TextInput {...props} />)
    },
    note_like: {
      title: 'note',
      component: (props) => (<TextInput {...props} />)
    }
  }

  const sorting = linkConst.DEFAULT_SORT[linkConst.LINK_YOUTUBE_ASSETS]

  return (<ListView
    store={store.cv}
    helper={store.helpFor(linkConst.LINK_YOUTUBE_ASSETS)}
    initOrder={{
      [sorting._sortField]: sorting._sortDir
    }}
    fields={fields}
    filters={() => Filters(store, filters)}
    onAddClicked={store.addClicked.bind(store)}
    batchActions={batchActions} />
  )
}
export default observer(YTAssetsListView)
